var defaultStyles = {
  "switch": "Base-Switch--Switch",
  "dot": "Base-Switch--Dot",
  "checked": "Base-Switch--Checked",
  "dot_icon": "Base-Switch--DotIcon",
  "text_holder": "Base-Switch--TextHolder",
  "text": "Base-Switch--Text",
  "loading": "Base-Switch--Loading",
  "small": "Base-Switch--Small",
  "icon": "Base-Switch--Icon",
  "square": "Base-Switch--Square",
  "line": "Base-Switch--Line"
};

export { defaultStyles as default };
